import type { JSX } from "react";
import type { NavItemMenuProps } from "./nav-item-menu";
import { Collapse, css, styled } from "@mui/material";
import { useObservable } from "ecce-react";
import { ExpandIcon } from "../../../../atoms/icons/expand-icon";
import { useNavSubMenuController } from "../../nav-sub-menu-controller";
import { NAV_BUTTON_CLASS_NAME, NavButton } from "../nav-button";
import { SingleNavItem } from "../nav-item"; // eslint-disable-line import/no-cycle
import { useNavItemActive } from "../use-nav-item-active";


const NavItemMenuInlineRoot = styled("div")(({ theme }) => css`
	position: relative;

	.navItemMenuInline__expandIcon {
		position: absolute;
		top: 0;
		right: 0;
		height: ${theme.layout.targetSize};

		display: grid;

		svg {
			margin: auto;
		}
	}

	.navItemMenuInline__items {
		display: flex;
		flex-direction: column;

		.${NAV_BUTTON_CLASS_NAME} {
			padding-inline-start: ${theme.spacing(2)};
		}
	}
`);

/**
 * Main nav menu for larger screens.
 */
export const NavItemMenuInline = (item: NavItemMenuProps): JSX.Element => {
	const controller = useNavSubMenuController();
	useObservable(controller, "openMenuLabelKey");

	const open = item.labelKey === controller.openMenuLabelKey;

	const menuId = item.labelKey + "Title";

	return (
		<NavItemMenuInlineRoot>
			<NavButton
				labelKey={ item.labelKey }
				icon={ item.icon }
				onClick={ () => controller.toggleMenuOpen(item.labelKey) }
				fullWidth
				aria-expanded={ open ? "true" : "false" }
				aria-controls={ menuId }
				noCloseMenu
				slim={ item.slim }
				active={ useNavItemActive(item) }
			/>
			<Collapse id={ menuId } in={ open }>
				<div className="navItemMenuInline__items">
					{ item.items.map(itemProps => (
						<SingleNavItem
							{ ...itemProps }
							key={ itemProps.labelKey }
						/>
					)) }
				</div>
			</Collapse>
			<div className="navItemMenuInline__expandIcon">
				<ExpandIcon expanded={ open }/>
			</div>
		</NavItemMenuInlineRoot>
	);
};